import React from 'react';

import {
  Col,
} from "react-bootstrap";

const ExperienceCard = ({ data }) => {
  return (
    <Col lg="4" className='card'>
      <div className="pb-5 text-center card-body">
        <img className=" bg-white mb-3" src={data.companylogo} alt="" style={{height:"110px"}}/>
        <p className="lead" style={{fontWeight:"700", marginBottom:"2px"}}>
          {data.company}          
        </p>
        <p className="lead" style={{fontStyle:"italic", fontWeight:"500", marginBottom:"2px"}}>
          {data.role}          
        </p>
        <p className="lead" style={{fontWeight:"400", marginBottom:"10px"}}>
          {data.stack}          
        </p>
        <p className="lead" style={{fontWeight:"400", fontSize: "1.05rem"}}>
          {data.date}
        </p>
        <p className="lead" style={{fontWeight:"400", fontSize: "1.05rem"}}>
          {data.work_done1}
        </p>
        {data.work_done2 && (<p className="lead" style={{fontWeight:"400", fontSize: "1.05rem"}}>
          {data.work_done2}
        </p>) }
        {data.work_done3 && (<p className="lead" style={{fontWeight:"400", fontSize: "1.05rem"}}>
          {data.work_done3}
        </p>) }
        {data.work_done4 && (<p className="lead" style={{fontWeight:"400", fontSize: "1.05rem"}}>
          {data.work_done4}
        </p>) }
        <a href={data.url} class="btn btn-primary" target="_blank">Code</a>

      </div>
    </Col>
  );
}

export default ExperienceCard;